import React, { Component } from 'react'
import Header from './Header'
import Video from './Video'
import VideoContent from './VideoContent'
// import Tool from './Tool'
import Operation from './Operation'
import Chat from './Chat'
import Style from './style.module.less'
import Store from './store'
import { Provider, observer } from 'mobx-react'
import { Breadcrumb } from 'hljd'

const Item = Breadcrumb.Item

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id }
    } = props
    this.store = new Store(id)
  }

  componentDidMount() {
    this.store.initData()
  }

  render() {
    const { detail = {}, isPreview, chatStore } = this.store
    return (
      <Provider store={this.store}>
        <div className={Style.page}>
          <Breadcrumb>
            <Item>
              <a href="#/localMerchant/liveManage">视频直播</a>
            </Item>
            {detail.title && <Item>{detail.title}</Item>}
          </Breadcrumb>
          {isPreview && <Header />}
          <div className={Style.main}>
            <div className={Style.left}>
              <Video />
              <VideoContent />
              {/*<Tool />*/}
            </div>
            <div className={Style.right}>
              <Operation />
              <Chat chatStore={chatStore} />
            </div>
          </div>
        </div>
      </Provider>
    )
  }
}
